import React from 'react'
import Styles from './OverviewInfoCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import IFText from 'Components/IFText/IFText'
import { useTranslation } from 'react-i18next'
import IFsvg from 'Components/IFsvg/IFsvg'
import OverviewInfoCardSkeleton from './OverviewInfoCardSkeleton'
import { getEnergyUnit } from 'Utils/Calculations'

const OverviewInfoCard = ({
  chargingSessions,
  chargingSessionsPercentage,
  energyConsumed,
  energyConsumedPercentage,
  averageConsumption,
  averageConsumptionPercentage,
  averageDuration,
  averageDurationPercentage,
  isLoading,
}) => {
  const { t } = useTranslation()

  const energy = energyConsumed || 0
  const { divisor: divisorConsumed, unit: unitConsumed } = getEnergyUnit(energy)
  const formattedEnergy = (energy / divisorConsumed).toFixed(1)

  const avg = averageConsumption || 0
  const { divisor: divisorAvg, unit: unitAvg } = getEnergyUnit(avg)
  const formattedAvg = (avg / divisorAvg).toFixed(1)
  return (
    <div
      style={{
        backgroundColor: Colors.white,
      }}
      className={Styles.Card}
    >
      {isLoading ? (
        <OverviewInfoCardSkeleton />
      ) : (
        <div className={Styles.Container}>
          <div className={Styles.Section}>
            <div className={Styles.Top}>
              <IFsvg.EvStation />
              <IFText
                style={{ color: Colors.Analytics.Icons }}
                className={Styles.Title}
              >
                {t('Analytics.ChargingSessions')}
              </IFText>
            </div>
            <div>
              <IFText style={{ color: Colors.black }} className={Styles.Value}>
                {chargingSessions}
              </IFText>
              <div className={Styles.Top}>
                <div
                  className={Styles.ArrowContainer}
                  style={{
                    backgroundColor:
                      chargingSessionsPercentage > 0
                        ? Colors.Analytics.LightGreen
                        : Colors.Analytics.LightRed,
                  }}
                >
                  <IFsvg.ArrowOutward
                    transform={
                      chargingSessionsPercentage > 0 ? 'none' : 'rotate(90deg)'
                    }
                    className={Styles.Arrow}
                    fill={
                      chargingSessionsPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red
                    }
                    height={16}
                    width={16}
                  />
                </div>
                <IFText
                  style={{
                    color:
                      chargingSessionsPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red,
                  }}
                  className={Styles.Percentage}
                >
                  {`${Math.abs(
                    parseFloat(chargingSessionsPercentage?.toFixed(1)),
                  ).toLocaleString()}%`}
                </IFText>
              </div>
            </div>
          </div>

          <div className={Styles.Section}>
            <div className={Styles.Top}>
              <IFsvg.Database />
              <IFText
                style={{ color: Colors.Analytics.Icons }}
                className={Styles.Title}
              >
                {t('Analytics.Consumed')}
              </IFText>
            </div>
            <div>
              <div className={Styles.Top}>
                <IFText
                  style={{ color: Colors.black }}
                  className={Styles.Value}
                >
                  {Number(formattedEnergy).toLocaleString()}
                </IFText>

                <IFText className={Styles.Unit}>{unitConsumed}</IFText>
              </div>
              <div className={Styles.Top}>
                <div
                  className={Styles.ArrowContainer}
                  style={{
                    backgroundColor:
                      energyConsumedPercentage > 0
                        ? Colors.Analytics.LightGreen
                        : Colors.Analytics.LightRed,
                  }}
                >
                  <IFsvg.ArrowOutward
                    transform={
                      energyConsumedPercentage > 0 ? 'none' : 'rotate(90deg)'
                    }
                    className={Styles.Arrow}
                    fill={
                      energyConsumedPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red
                    }
                    height={16}
                    width={16}
                  />
                </div>
                <IFText
                  style={{
                    color:
                      energyConsumedPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red,
                  }}
                  className={Styles.Percentage}
                >
                  {`${Math.abs(
                    parseFloat(energyConsumedPercentage?.toFixed(1)),
                  ).toLocaleString()}%`}
                </IFText>
              </div>
            </div>
          </div>

          <div className={Styles.Section}>
            <div className={Styles.Top}>
              <IFsvg.MobileCharge />
              <IFText
                style={{ color: Colors.Analytics.Icons }}
                className={Styles.Title}
              >
                {t('Analytics.AverageConsumption')}
              </IFText>
            </div>
            <div>
              <div className={Styles.Top}>
                <IFText
                  style={{ color: Colors.black }}
                  className={Styles.Value}
                >
                  {Number(formattedAvg).toLocaleString()}
                </IFText>

                <IFText className={Styles.Unit}>{unitAvg}</IFText>
              </div>
              <div className={Styles.Top}>
                <div
                  className={Styles.ArrowContainer}
                  style={{
                    backgroundColor:
                      averageConsumptionPercentage > 0
                        ? Colors.Analytics.LightGreen
                        : Colors.Analytics.LightRed,
                  }}
                >
                  <IFsvg.ArrowOutward
                    transform={
                      averageConsumptionPercentage > 0
                        ? 'none'
                        : 'rotate(90deg)'
                    }
                    className={Styles.Arrow}
                    fill={
                      averageConsumptionPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red
                    }
                    height={16}
                    width={16}
                  />
                </div>
                <IFText
                  style={{
                    color:
                      averageConsumptionPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red,
                  }}
                  className={Styles.Percentage}
                >
                  {`${Math.abs(
                    parseFloat(averageConsumptionPercentage?.toFixed(1)),
                  ).toLocaleString()}%`}
                </IFText>
              </div>
            </div>
          </div>

          <div className={Styles.Section}>
            <div className={Styles.Top}>
              <IFsvg.AverageTime />
              <IFText
                style={{ color: Colors.Analytics.Icons }}
                className={Styles.Title}
              >
                {t('Analytics.AverageDuration')}
              </IFText>
            </div>
            <div>
              <div className={Styles.Top}>
                <IFText
                  style={{ color: Colors.black }}
                  className={Styles.Value}
                >
                  {`${Math.abs(
                    parseFloat(averageDuration?.toFixed(1)),
                  ).toLocaleString()}`}
                </IFText>
                <IFText className={Styles.Unit}>{t('Analytics.Hours')}</IFText>
              </div>
              <div className={Styles.Top}>
                <div
                  className={Styles.ArrowContainer}
                  style={{
                    backgroundColor:
                      averageDurationPercentage > 0
                        ? Colors.Analytics.LightGreen
                        : Colors.Analytics.LightRed,
                  }}
                >
                  <IFsvg.ArrowOutward
                    transform={
                      averageDurationPercentage > 0 ? 'none' : 'rotate(90deg)'
                    }
                    className={Styles.Arrow}
                    fill={
                      averageDurationPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red
                    }
                    height={16}
                    width={16}
                  />
                </div>
                <IFText
                  style={{
                    color:
                      averageDurationPercentage > 0
                        ? Colors.Analytics.GreenPercentage
                        : Colors.red,
                  }}
                  className={Styles.Percentage}
                >
                  {`${Math.abs(
                    parseFloat(averageDurationPercentage?.toFixed(1)),
                  ).toLocaleString()}%`}
                </IFText>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

OverviewInfoCard.propTypes = {
  chargingSessions: PropTypes.number,
  chargingSessionsPercentage: PropTypes.number,
  energyConsumed: PropTypes.number,
  energyConsumedPercentage: PropTypes.number,
  averageConsumption: PropTypes.number,
  averageConsumptionPercentage: PropTypes.number,
  averageDuration: PropTypes.number,
  averageDurationPercentage: PropTypes.number,
  isLoading: PropTypes.bool,
}

export default OverviewInfoCard
